export default {"src":"/_next/static/media/discount.e34011ff.svg","height":100,"width":150};